import Leads from './list/leads'
import Proposals from './list/proposals'
import Paid from './list/paid'
import Archive from './list/archive'
import Passport from './list/passport'
import SendProposal from './send-proposal'
import EditProposal from './edit-proposal'

export default [
  {
    value: 'leads',
    title: 'Leads',
    description:
      'From your leads dashboard, you can manage all incoming leads from FlySpaces with most recent Leads at the top. Closing a Lead is simple as 1-2-3!',
    component: Leads,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'proposals',
    title: 'Proposals',
    description:
      `From the table you can track the status of all the Proposals you have sent to clients with request for payment. The status of all Proposals will be "Pending Payment" until the Client has completed payment, so make sure to message the client if you don't hear back within 24 hours! After being paid, the Lead will move to the next tab, Paid.`,
    component: Proposals,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'paid',
    title: 'Paid',
    description:
      'From this table you will see all confirmed bookings for your spaces. This statuses will either be Paid (paid via credit card online) or Pending Bank Deposit (will be transferred manually). Next step is to prepare for the client!',
    component: Paid,
    iconSeparator: 'fa fa-angle-right'
  },
  {
    value: 'archive',
    title: 'Archive',
    description:
      'When you decline, cancel or archive a request, it will appear here for you to have a record of.',
    component: Archive,
    separator: '|'
  },

  {
    value: 'passport',
    title: 'Passport',
    description:
      'Here you can see only your Passport coworking bookings. We keep these seperate as they have a direct bookings functionalty -0 client simply make the booking, and then confirm the following via QR code scan at check0in. If QR code confirmation is not possible then you simply need to update the status by clicking Confirm Banking when the client has arrived at your space.',
    component: Passport,
    textColor: 'text-midnight-blue'
  },
]

export const switchableComponentObj = [
  { value: 'send-proposal', component: SendProposal },
  { value: 'edit-proposal', component: EditProposal },
]

export const leadsInstruction = [
  {
    title: 'ACCEPT THE LEAD',
    description:
      `This is the first step! By accepting the lead you will then be able to freely message the client and see their contact details.`,
  },
  {
    title: 'SEND A MESSAGE TO THE CLIENT',
    description:
      `With the FlySpaces Platform, you can then message the client to discuss all details`,
  },
  {
    title: 'SEND A REQUEST FOR PAYMENT',
    description:
      `After discussing terms with the client, send a proposal with a payment link (either on this page, or via the Messages tab). After which your Lead will move to the Proposals tab where you can view it's status.`,
  },
]

export const leadCancelReasons = [
  'The space is already booked',
  'The space cannot accommodate the request',
  'The space is closed on the booking date',
]

export const declineInquiryReasons = [
  'The space is already booked',
  'The space cannot accommodate the request',
  'The space is closed on the booking date',
]

export const statusSchema = {
  accepted: 'bg-panache text-secondary-green',
  expired: 'bg-ct-gray text-ct-gray',
  pending: 'bg-old-lace text-primary-orange',
  declined: 'bg-tutu text-monza',
  cancelledByClient: 'bg-tutu text-monza',
  cancelledBySpace: 'bg-tutu text-monza',
  pendingPayment: 'bg-old-lace text-primary-orange',
  paid: 'bg-panache text-secondary-green',
  pendingBankDeposit: 'bg-old-lace text-primary-orange',
  booked: 'bg-old-lace text-primary-orange',
  confirmed: 'bg-panache text-secondary-green',
  cancelled: 'bg-tutu text-monza',
}
